import { create } from "zustand";
import { fetchContactDirectory } from "api/contacts";
import { FirebaseAuth } from "utils/firebase";

// The server caches the directory for 10 minutes, so refetching sooner
// would return the same list.
const REFRESH_AFTER_MS = 10 * 60 * 1000;

const EMPTY = { contacts: [], uid: null, loadedAt: 0, loadingUid: null };

export const useContactDirectoryStore = create((set, get) => ({
  ...EMPTY,
  // Safe to call from every picker mount; it fetches at most once per window
  // and never throws, because a picker must work without suggestions.
  load: async () => {
    const uid = FirebaseAuth.currentUser?.uid || null;
    const state = get();
    if (!uid || state.loadingUid === uid) return;
    if (state.uid === uid && Date.now() - state.loadedAt < REFRESH_AFTER_MS) return;

    // A different account never sees the previous account's people.
    set(state.uid === uid ? { loadingUid: uid } : { ...EMPTY, uid, loadingUid: uid });
    let contacts = null;
    try {
      contacts = await fetchContactDirectory();
    } catch (error) {
      console.warn("[contacts] directory load failed", error.message);
    }

    // Drop the response if the account changed while it was in flight.
    if (FirebaseAuth.currentUser?.uid !== uid || get().uid !== uid) return;
    set({
      ...(contacts ? { contacts } : {}),
      loadedAt: Date.now(),
      loadingUid: null,
    });
  },
  clear: () => set(EMPTY),
}));

FirebaseAuth.onAuthStateChanged?.((user) => {
  if (useContactDirectoryStore.getState().uid !== (user?.uid || null)) {
    useContactDirectoryStore.getState().clear();
  }
});
